import { render, staticRenderFns } from "./ProfessionalDevelopmentView.vue?vue&type=template&id=febf62fa&scoped=true"
import script from "./ProfessionalDevelopmentView.vue?vue&type=script&lang=js"
export * from "./ProfessionalDevelopmentView.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalDevelopmentView.vue?vue&type=style&index=0&id=febf62fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf62fa",
  null
  
)

export default component.exports